// removed by extract-text-webpack-plugin
module.exports = {"skeleton":"styles__skeleton___3ifx7","skeleton-loading":"styles__skeleton-loading___39N5o","whiteBackgroundSkeleton":"styles__whiteBackgroundSkeleton___B-poT","greenBackgroundSkeleton":"styles__greenBackgroundSkeleton___3_y8l","skeleton-green":"styles__skeleton-green___1uP_g","skeleton-loader-gradient":"styles__skeleton-loader-gradient___2c-Vr","mainSectionSkeleton":"styles__mainSectionSkeleton___1-NBB","skeletonText":"styles__skeletonText___nmAXn","cardSkeleton":"styles__cardSkeleton___2gTSN","skeleton-loading-green":"styles__skeleton-loading-green___17JQD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Skeleton/MenuNavegationSkeleton/styles.css
// module id = 2546
// module chunks = 0